export default "__VITE_ASSET__DctxOlJI__"